import type { FC, HTMLAttributes } from "react";

import {
  PAGINATION_ELLIPSIS_CLASS,
} from "@/ui/components/navigation/Pagination/Pagination.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { cn } from "@/ui/lib/utils";

export const PaginationEllipsis: FC<HTMLAttributes<HTMLSpanElement>> = (
  {
    className,
    ...props
  },
) => (
  <span {...props} data-component="PaginationEllipsis" className={cn(PAGINATION_ELLIPSIS_CLASS, className)}>
    <Icon icon="ellipsis" size="sm" aria-hidden="true" />
    <span className="sr-only">More pages</span>
  </span>
);

PaginationEllipsis.displayName = "PaginationEllipsis";
